import React from "react";
import { useState } from "react";
import "../assets/styles/overview.css";
import PaintingOverview from "../components/PaintingOverview";
import { allPaintingsList } from "../data/data";

function Portfolio() {
  const [paintings] = useState(allPaintingsList);

  return (
    <>
      <PaintingOverview paintings={paintings} category_name="all" />
    </>
  );
}

export default Portfolio;
